import { Injectable } from '@angular/core';
import { GetTimestampFromTime } from '@dave/types';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concatMap, EMPTY, firstValueFrom, from, mergeMap, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { isNotNullOrUndefined } from '../../../helper/helper';
import { UglImportTaskActionTypes } from '../actions/ugl-import-task.actions';
import { UglImportTaskEntityFromBackend } from '../../entities/ugl-import-task.entity';
import { BaseActionTypes } from '../actions/base.actions';
import { DaveActions } from '../actions/actions';
import { State } from '../index';
import { AppGatewayService } from '../../services/app-gateway.service';
import { getUglImportTaskDictionary } from '../selectors/ugl-import-task.selector';


enum ErrorCodes {
    Add = 'Ftp verbindung Hinzufügen fehlgeschlagen',
    Load = 'Ftp verbindung Abrufen fehlgeschlagen',
    Modify = 'Ftp verbindung Bearbeiten fehlgeschlagen',
    Remove = 'Ftp verbindung Löschen fehlgeschlagen',
}

@Injectable()
export class UglImportTaskEffects {
    ModifyUglImportTask$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UglImportTaskActionTypes.Change),
            concatMap(({ Payload }) =>
                this.gatewayService
                    .Request({ UglImportEditUglImportTask: Payload })
                    .then((res) => {
                        if (Object.keys(res?.Errors || {}).length === 0) {
                            return UglImportTaskActionTypes.UpdateOne({ Payload: UglImportTaskEntityFromBackend(res.UglImportEditUglImportTask.Task) });
                        } else {
                            throw res.Errors;
                        }
                    })
                    .catch((err) =>
                        BaseActionTypes.ErrorAction({
                            Payload: {
                                ToasterMessage: ErrorCodes.Modify,
                                Err: err,
                            },
                        }),
                    ),
            ),
        ),
    );

    DeleteUglImportTask$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UglImportTaskActionTypes.Delete),
            concatMap(({ Payload }) =>
                this.gatewayService
                    .Request({ UglImportDeleteUglImportTask: Payload })
                    .then((res) => {
                        if (Object.keys(res?.Errors || {}).length === 0) {
                            return UglImportTaskActionTypes.RemoveOne({ Payload: +Payload.Id });
                        } else {
                            throw res.Errors;
                        }
                    })
                    .catch((err) =>
                        BaseActionTypes.ErrorAction({
                            Payload: {
                                ToasterMessage: ErrorCodes.Remove,
                                Err: err,
                            },
                        }),
                    ),
            ),
        ),
    );

    AddUglImportTask$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UglImportTaskActionTypes.CreateRequest),
            concatMap(({ Payload }) =>
                this.gatewayService
                    .Request({ UglImportCreateUglImportTask: Payload })
                    .then((res) => {
                        if (Object.keys(res?.Errors || {}).length === 0) {
                            return UglImportTaskActionTypes.CreateSuccess({
                                Payload: UglImportTaskEntityFromBackend(res.UglImportCreateUglImportTask.Task),
                            });
                        } else {
                            throw res.Errors;
                        }
                    })
                    .catch((err) =>
                        UglImportTaskActionTypes.CreateFailure({
                            Payload: {
                                ToasterMessage: ErrorCodes.Add,
                                Errors: err,
                            },
                        }),
                    ),
            ),
        ),
    );

    LoadUglImportTasks = createEffect(() => {
        return this.actions$.pipe(
            ofType(UglImportTaskActionTypes.Load),
            switchMap(({ Payload }) => {
               // const requestPayload = isNotNullOrUndefined(Payload?.updatedSince) ? { UpdatedAt: Payload.updatedSince, WithDeleted: true } : { WithDeleted: true };
                    const requestPayload = {WithDeleted: false};
                return from(this.gatewayService.Request({ UglImportGetUglImportTasks: requestPayload })).pipe(
                    mergeMap((res) => {
                        if (Object.keys(res?.Errors || {}).length === 0) {
                            /*if (!isNotNullOrUndefined(Payload.updatedSince)) {
                                return of(
                                    UglImportTaskActionTypes.UpdateAll({
                                        Payload: res.UglImportGetUglImportTasks.Tasks.map((val) => UglImportTaskEntityFromBackend(val)),
                                      //  updateLatestUpdatedAt: true,
                                    }),
                                );
                            } else*/ if (res.UglImportGetUglImportTasks.Tasks.length) {
                                return from(firstValueFrom(this.store$.select(getUglImportTaskDictionary))).pipe(
                                    mergeMap((UglImportTasks) => {
                                        const filteredUglImportTasks = res.UglImportGetUglImportTasks.Tasks.filter((UglImportTask) => {
                                            const fromState = UglImportTasks[UglImportTask.Id];
                                            return !fromState || GetTimestampFromTime(fromState.UpdatedAt).toString() !== UglImportTask.UpdatedAt;
                                        });

                                        if (filteredUglImportTasks.length) {
                                            return of(
                                                UglImportTaskActionTypes.UpdateMany({
                                                    Payload: filteredUglImportTasks.map((val) => UglImportTaskEntityFromBackend(val)),
                                                   // updateLatestUpdatedAt: true,
                                                }),
                                            );
                                        } else {
                                            return EMPTY;
                                        }
                                    }),
                                );
                            }
                            return EMPTY;
                        } else {
                            throw res.Errors;
                        }
                    }),
                    catchError((err) =>
                        of(
                            BaseActionTypes.ErrorAction({
                                Payload: {
                                    ToasterMessage: ErrorCodes.Load,
                                    Err: err,
                                },
                            }),
                        ),
                    ),
                );
            }),
        );
    });
    error$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UglImportTaskActionTypes.CreateFailure),
            map(({ Payload }) =>
                BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: Payload.ToasterMessage,
                        Err: Payload.Errors,
                    },
                }),
            ),
        ),
    );
    constructor(private actions$: Actions<DaveActions>, private store$: Store<State>, private gatewayService: AppGatewayService) {}
}
